import { createSlice } from '@reduxjs/toolkit';
export const preferencesInitialState = {
    theme: localStorage.getItem('theme') || 'light',
    language: 'en',
    hasViewedWelcomeSlides: false,
};
const preferencesSlice = createSlice({
    name: 'preferences',
    initialState: preferencesInitialState,
    reducers: {
        toggleTheme: (state) => {
            const newTheme = state.theme === 'light' ? 'dark' : 'light';
            localStorage.setItem('theme', newTheme);
            state.theme = newTheme;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setHasViewedWelcomeSlides: (state) => {
            state.hasViewedWelcomeSlides = true;
            localStorage.setItem('hasViewedWelcomeSlides', 'true');
        },
    },
});
export const { toggleTheme, setLanguage, setHasViewedWelcomeSlides } = preferencesSlice.actions;
export const preferencesReducer = preferencesSlice.reducer;
export default preferencesSlice;
